module.exports = __webpack_public_path__ + "static/adel-2ffee6769c284b3897af9a0436b84473.jpg";